import * as React from 'react';
import { memo } from 'react';
const NoFlavour = (props) => (

  <svg width="65" height="66" viewBox="0 0 65 66" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32.5" cy="33" r="31.85" fill="#FFFEF6" stroke="#212322" stroke-width="1.3"/>
    <line x1="48.4614" y1="5.79009" x2="16.8371" y2="60.5649" stroke="#212322" stroke-width="1.3"/>
  </svg>

  
);
const Memo = memo(NoFlavour);
export default Memo;
